export default {
  bookmarks: []
}
